// extracted by mini-css-extract-plugin
export default {"wrapper":"mc5Zs","formWrapper":"QAziq","buttons":"S092I","form":"pn9vj","formItem":"Yoq_E","input":"hKkHG","inputRoot":"anwJ3","ssoButton":"pb98d","error":"IYp2P"};